import { CoverageCatalog, moneyFormat } from 'design-system';
import LUC from 'src/constants/coveragesCodes';
import { getTypeOfQuotation, typeOfQuotation } from './individualOptionHelpers';

const { formatMoney } = moneyFormat;

export const getDeductibleDisplayText = (
  deductibleType: string,
  value: number,
  percentage: number,
  moneyType: string | undefined,
  coverageId: string,
  packageOption: number,
  createdAt?: string,
): string => {
  const quotationType = getTypeOfQuotation(createdAt);
  const coverages =
    typeOfQuotation[quotationType].packageOptions?.[packageOption];
  const deductibleText = coverages?.includes(coverageId) ? 'de la pérdida' : '';
  if (deductibleType === 'P') return `${percentage}% ${deductibleText}`;
  return formatMoney(value, false, moneyType);
};

export const getDeductibleHelperText = (
  deductibleType: string,
  value: number,
  moneyType: string | undefined,
): string => {
  if (deductibleType === 'M') return `Fijos por evento`;
  return `Con mínimo de ${formatMoney(value, false, moneyType)}`;
};

export const getDeductibleDefaultBase = (
  packageOption: number,
  coverageId: string,
  createdAt?: string,
): string => {
  const quotationType = getTypeOfQuotation(createdAt);
  const coverages =
    typeOfQuotation[quotationType].packageOptions?.[packageOption];
  if (!coverages) return 'M';
  if (coverages.includes(coverageId)) return 'P';
  return 'M';
};

export const orderCoverageCatalog = (
  coverageCatalogList: CoverageCatalog[],
): CoverageCatalog[] => {
  const resume: CoverageCatalog[] = [];
  coverageCatalogList.forEach((item) => {
    if (item.code === LUC) {
      resume.unshift(item);
    } else {
      resume.push(item);
    }
  });
  return resume;
};
